import "./InputForm.css"
import Input from "../../Model/Input";
import Button from "../../Model/Button";
// import '../bootstrap/dist/css/bootstrap.min.css';

interface InputFormProps {
    HandleOnSubmit: (e: any) => void;
    inputs: Input[];
    error: string;
    buttons: Button[];
    children: never[];
}

export default function InputForm(props: InputFormProps) {
    return (
        <div className="InputForm">
            <form className="InputForm-form" onSubmit={props.HandleOnSubmit}>
                {
                    props.inputs.map((input, index) => {
                        return (
                            <div key={index} className="InputForm-input">
                                <div className="InputForm-input-title">{input.title} :</div>
                                <input type={input.type} className={input.className} placeholder={input.placeHolder} onChange={input.HandleOnChange} autoComplete="on" required></input>
                            </div>
                        )
                    })
                }
                <div style={{marginLeft: "4vw", color: "#ee767e"}}>{props.error}</div>
                {
                    props.buttons.map((button, index) => {
                        return (
                            button.isLoading ?
                                <button key={index}
                                    className={button.className}
                                    type={button.type}
                                    style={{ marginTop: "2vh", marginBottom: "4vh", marginLeft: "4vw" }}
                                    disabled>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    {" " + button.title}
                                </button> :
                                <button key={index}
                                    className={button.className}
                                    onClick={button.onClick}
                                    type={button.type}
                                    style={{ marginTop: "2vh", marginBottom: "4vh", marginLeft: "4vw" }}>{button.title}
                                </button>
                        )
                    })
                }
            </form>
        </div>
    )
}